import { render, staticRenderFns } from "./ReviewYourAnswers.vue?vue&type=template&id=444bfa4d&scoped=true"
import script from "./ReviewYourAnswers.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444bfa4d",
  null
  
)

export default component.exports